module.exports = __webpack_public_path__ + "static/img/6.388c305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/6.png
// module id = lzdC
// module chunks = 0